import script from "./work-order-quotation-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./work-order-quotation-modal.vue?vue&type=script&setup=true&lang=ts"

import "./work-order-quotation-modal.vue?vue&type=style&index=0&id=5896ceb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5896ceb2"]])

export default __exports__